import React, { ReactElement } from "react";

interface Props {
  label: string;
  value: string;
}

export function VideoInfoBoxItem(props: Props): ReactElement {
  return (
    <div className="InfoBoxItem">
      <span className="InfoBoxItem__label">{props.label}</span>
      <span className="InfoBoxItem__value">{props.value}</span>
    </div>
  );
}
